module.exports = __webpack_public_path__ + "img/logo-7.a3979c4a.svg";